import React from "react";
import { Dropdown, Popover, Whisper } from "rsuite";
import { AppRouteApi } from "../config/appRoute";
import downloadIcon from "../assets/img/download-icon.svg";
import { LibExport } from "../libs/exportDownload";
import { PagedRequestParam } from "../models/api";

type ApiComponentNameType =
  | "PatientTask"
  | "Patient"
  | "Caregiver"
  | "Company"
  | "Users"
  | "Appointment";

const RenderMenu = React.forwardRef(
  (
    {
      onClose,
      className,
      left,
      top,
      component,
      params,
    }: {
      onClose: any;
      className: any;
      left: any;
      top: any;
      component: ApiComponentNameType;
      params: PagedRequestParam;
    },
    ref: React.Ref<HTMLDivElement>
  ) => {
    const handleSelect = (eventKey: any) => {
      onClose();
    };

    return (
      <Popover ref={ref} className={className} style={{ left, top }} full>
        <Dropdown.Menu onSelect={handleSelect}>
          <Dropdown.Item
            onClick={() => {
              LibExport.DownloadExportPaginated(
                AppRouteApi[component].Export("Csv"),
                `${component}-Paginated.csv`,
                params
              );
            }}
            eventKey={1}
          >
            Current Page (CSV)
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => {
              LibExport.DownloadExportPaginated(
                AppRouteApi[component].Export("Excel"),
                `${component}-Paginated.xlsx`,
                params
              );
            }}
            eventKey={2}
          >
            Current Page (Excel)
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => {
              LibExport.DownloadExportPaginated(
                AppRouteApi[component].ExportAll("Csv"),
                `${component}-All.csv`
              );
            }}
            eventKey={3}
          >
            All Data (CSV)
          </Dropdown.Item>

          <Dropdown.Item
            onClick={() => {
              LibExport.DownloadExportPaginated(
                AppRouteApi[component].ExportAll("Excel"),
                `${component}-All.xlsx`
              );
            }}
            eventKey={4}
          >
            All Data (Excel)
          </Dropdown.Item>
        </Dropdown.Menu>
      </Popover>
    );
  }
);

export const ExportButton = ({
  component,
  params,
}: {
  component: ApiComponentNameType;
  params: PagedRequestParam;
}) => (
  <Whisper
    placement="bottomEnd"
    trigger="click"
    speaker={(props, ref) => (
      <RenderMenu component={component} params={params} ref={ref} {...props} />
    )}
  >
    <a className="btn search-filter-btn me-3" href="#filterPanel">
      <img
        src={downloadIcon}
        alt="filter-panel-icon"
        className="img-fluid svg-btn"
      />
    </a>
  </Whisper>
);
